import { getWindow } from '@acorns/web-utils'

import createEnvironment from 'config/env'

import { FlowProviderActionProps, FlowRoute } from '../../types'
import { DEFAULT_FUNNEL_NAME } from '../../utils'

const environment = createEnvironment()
const webAppUrl = environment.get('webAppUrl')

export const finishOnboarding = (_, props: FlowProviderActionProps): FlowRoute => {
  if (!props.isRegistrationFlow) {
    if (props.isAnalytics) {
      // type cast only for analytics
      return 'present' as FlowRoute
    }

    getWindow().location.replace(webAppUrl)
    return
  }

  props.setFlow(DEFAULT_FUNNEL_NAME)
  return FlowRoute.ProductOnboarding
}
